// 设备管理
import http from "@/jslibs/axios/http";

// 新增设备
export const add = (data) => http.post("/cms/loadDevice/add", data);

// 编辑设备
export const edit = (data) => http.post("/cms/loadDevice/update", data);

// 设备状态批量修改
export const updateStatus = (data) => http.post("/cms/loadDevice/updateStatus", data);

// 设备详情
export const detail = (id) => http.get("/cms/loadDevice/details/" + id);

// 设备分页列表
export const page = (data) => http.get("/cms/loadDevice/page", data);

// 设备删除
export const del = (id) => http.delete("/cms/loadDevice/" + id);

// 设备导入模板
export const excelStencil = () => http.post("/cms/loadDevice/excelStencil", {}, { responseType: "blob" });

// 设备导出
export const excel = (data) => http.post("/cms/loadDevice/excel", data, { responseType: "blob" });

// 设备导入
export const importExcel = ({ file }) => {
    const params = new FormData();
    params.append("file", file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
    };
    return http.post("/cms/loadDevice/importExcel", params, config);
};